import React, { FC } from 'react';
import MainLayout from '../../Layouts/MainLayout';

const PageNotFound: FC = () => {
  return (
    <MainLayout>
      <div className="container vh-100 d-flex flex-column justify-content-center align-items-center">
        <h1 className="display-4 text-danger mb-4">404</h1>
        <h2 className="text-muted mb-3">Page Not Found</h2>
        <p className="text-secondary">
          The page you are looking for might have been removed or is temporarily unavailable.
        </p>
        <a href="/" className="btn SaveBtn mt-3">
          Go to Home
        </a>
      </div>
    </MainLayout>

  );
};

export default PageNotFound;
